<template>
  <div>
    <div class="title max-width">个人中心</div>
    <div class="service-page max-width">
      <div class="left">
        <div v-if="isFaren" class="left-item" :class="['/user/myProduct' === currentpath ? 'active' : '']" @click="select('/user/myProduct')">我的产品</div>
        <div class="left-item" :class="['/user/myService' === currentpath ? 'active' : '']" @click="select('/user/myService')">我的诉求</div>
        <div class="left-item" :class="['/user/myCollection' === currentpath ? 'active' : '']" @click="select('/user/myCollection')">我的收藏</div>
      </div>
      <div class="right box">
        <router-view class="container" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    currentpath() {
      return this.$route.path
    },
    isFaren() {
      return this.$store.state.userInfo.zlbType === 1
      // return true
    },
  },
  mounted() {
    if (this.$route.path == '/user') {
      if (this.isFaren) {
        this.select('/user/myProduct')
      } else {
        this.select('/user/myService')
      }
    }
  },
  updated() {
    if (this.$route.path == '/user') {
      if (this.isFaren) {
        this.select('/user/myProduct')
      } else {
        this.select('/user/myService')
      }
    }
  },
  methods: {
    select(path) {
      this.$router.push({
        path,
      })
    },
  },
}
</script>

<style lang="less" scoped>
@media screen {
  .title {
    font-family: PingFangSC-Medium;
    font-size: 24px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
    margin: 20px 0 12px 0;
  }
  .service-page {
    display: flex;
    color: #333333;
    .box {
      background: #ffffff;
      box-shadow: 0px 2px 9px 0px rgba(235, 236, 244, 1);
      border-radius: 10px;
      padding: 16px 24px;
      font-family: PingFangSC-Regular;
      font-size: 20px;
      color: #333333;
      letter-spacing: 0;
      font-weight: 400;
      margin-bottom: 12px;
      .box-title {
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 600;
      }
    }
    .right {
      flex: 1;
      flex-shrink: 0;
    }
    .left {
      width: 160px;
      flex-shrink: 0;
      margin-right: 20px;
      padding: 20px;
      background: #fff;
      border-radius: 4px;
      .left-item {
        cursor: pointer;
        border-radius: 6px;
        padding: 14px 0;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        // transition: all 0.3s;
        &.active {
          background-image: linear-gradient(110deg, #5787ff 0%, #1b5bfa 100%);
          box-shadow: 0px 3px 10px 0px rgba(30, 194, 203, 0.53);
          color: rgba(255, 255, 255, 0.99);
        }
      }
    }
  }
  @media (min-width: 769px) {
  }

  @media (max-width: 768px) {
  }
}
</style>
